import type { ThemeClasses } from "../../types/components";

// Standard themeClasses object shared across the Gestión de Staff screens
// (mirrors the Nuvex Access scaffold so both surfaces look identical).
export const buildThemeClasses = (isDarkMode: boolean): ThemeClasses => ({
  bg: isDarkMode ? "bg-dark-surface" : "bg-white",
  border: isDarkMode ? "border-dark-border" : "border-gray-200",
  text: isDarkMode ? "text-white" : "text-gray-900",
  textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
  cardBg: isDarkMode ? "bg-dark-card" : "bg-white",
  cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  buttonHover: isDarkMode ? "hover:bg-dark-card" : "hover:bg-gray-100",
  buttonText: isDarkMode ? "text-gray-400" : "text-gray-600",
  buttonTextHover: isDarkMode ? "hover:text-white" : "hover:text-gray-900",
});
